var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-primary cursor-pointer",on:{"click":_vm.handleSupplierNameClick}},[_vm._v(" "+_vm._s(_vm.rowData.name)+" ")]),_vm._v(" "),_c('small',{staticClass:"d-block text-muted my-1"},[_vm._v("#"+_vm._s(_vm.rowData.supplier_no))])])
}
var staticRenderFns = []

export { render, staticRenderFns }